var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ProductCardLink_instances, setImageSrcset_fn, _fetchProductPageHandler, _navigateToURL, _ProductCard_instances, preloadNextPreviewImage_fn, _handleQuickAdd, _handleVariantSelected, _handleVariantUpdate, updateOverflowList_fn, updateProductUrl_fn, isUnavailableVariantSelected_fn, toggleAddToCartButton_fn, updateVariantImages_fn, _previousSlideIndex, _handleSlideshowSelect, _resetVariant, _SwatchesVariantPickerComponent_instances, handleCardVariantUrlUpdate_fn;
import { OverflowList } from "@theme/overflow-list";
import VariantPicker from "@theme/variant-picker";
import { Component } from "@theme/component";
import { debounce, isDesktopBreakpoint, mediaQueryLarge, yieldToMainThread } from "@theme/utilities";
import { ThemeEvents, VariantSelectedEvent, VariantUpdateEvent, SlideshowSelectEvent } from "@theme/events";
import { morph } from "@theme/morph";
class ProductCardLink extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductCardLink_instances);
  }
  get productTransitionEnabled() {
    return this.getAttribute("data-product-transition") === "true";
  }
  get featuredMediaUrl() {
    return this.getAttribute("data-featured-media-url");
  }
  /**
   * Handles the click event for view transitions.
   * @param {Event} event
   */
  handleViewTransition(event) {
    if (event.defaultPrevented) return;
    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest('button, input, label, select, [tabindex="1"]');
      if (interactiveElement) return;
    }
    if (!this.productTransitionEnabled) return;
    const { cardGallery } = this.refs;
    if (!cardGallery || !cardGallery.hasAttribute("data-view-transition-to-main-product")) return;
    const { imagesToTransition } = this.refs;
    const activeImage = imagesToTransition?.find(
      (image) => image.closest("slideshow-slide")?.getAttribute("aria-hidden") === "false"
    ) || imagesToTransition?.[imagesToTransition.length - 1];
    if (activeImage instanceof HTMLImageElement) __privateMethod(this, _ProductCardLink_instances, setImageSrcset_fn).call(this, activeImage);
    cardGallery.setAttribute("data-view-transition-type", "product-image-transition");
    cardGallery.setAttribute("data-view-transition-triggered", "true");
  }
}
_ProductCardLink_instances = new WeakSet();
/**
 * Sets the srcset for the image
 * @param {HTMLImageElement} image
 */
setImageSrcset_fn = function(image) {
  if (!this.featuredMediaUrl) return;
  const currentImageUrl = new URL(image.currentSrc);
  const currentImageRawUrl = currentImageUrl.host + currentImageUrl.pathname;
  if (!this.featuredMediaUrl.includes(currentImageRawUrl)) {
    const imageFade = image.animate([{ opacity: 0.8 }, { opacity: 1 }], {
      duration: 125,
      easing: "ease-in-out"
    });
    imageFade.onfinish = () => {
      image.srcset = this.featuredMediaUrl ?? "";
    };
  }
};
if (!customElements.get("product-card-link")) {
  customElements.define("product-card-link", ProductCardLink);
}
class ProductCard extends ProductCardLink {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductCard_instances);
    __publicField(this, "requiredRefs", ["productCardLink"]);
    __privateAdd(this, _fetchProductPageHandler, () => {
      this.refs.quickAdd?.fetchProductPage(this.productPageUrl);
    });
    /**
     * Navigates to a URL link. Respects modifier keys for opening in new tab/window.
     * @param {Event} event - The event that triggered the navigation.
     * @param {URL} url - The URL to navigate to.
     */
    __privateAdd(this, _navigateToURL, (event, url) => {
      const shouldOpenInNewTab = event instanceof MouseEvent && (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1);
      if (shouldOpenInNewTab) {
        event.preventDefault();
        window.open(url.href, "_blank");
        return;
      } else {
        window.location.href = url.href;
      }
    });
    /**
     * Handles the quick add event.
     */
    __privateAdd(this, _handleQuickAdd, () => {
      this.removeEventListener("pointerenter", __privateGet(this, _fetchProductPageHandler));
      this.removeEventListener("focusin", __privateGet(this, _fetchProductPageHandler));
      if (isDesktopBreakpoint()) {
        this.addEventListener("pointerenter", __privateGet(this, _fetchProductPageHandler));
        this.addEventListener("focusin", __privateGet(this, _fetchProductPageHandler));
      }
    });
    /**
     * Handles the variant selected event.
     * @param {VariantSelectedEvent} event - The variant selected event.
     */
    __privateAdd(this, _handleVariantSelected, (event) => {
      if (event.target !== this.variantPicker) {
        this.variantPicker?.updateSelectedOption(event.detail.resource.id);
      }
    });
    /**
     * Handles the variant update event.
     * Updates price, checks for unavailable variants, and updates product URL.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    __privateAdd(this, _handleVariantUpdate, (event) => {
      event.stopPropagation();
      this.updatePrice(event);
      __privateMethod(this, _ProductCard_instances, isUnavailableVariantSelected_fn).call(this, event);
      __privateMethod(this, _ProductCard_instances, updateProductUrl_fn).call(this, event);
      this.refs.quickAdd?.fetchProductPage(this.productPageUrl);
      if (event.target !== this.variantPicker) {
        this.variantPicker?.updateVariantPicker(event.detail.data.html);
      }
      __privateMethod(this, _ProductCard_instances, updateVariantImages_fn).call(this);
      __privateSet(this, _previousSlideIndex, null);
      this.removeAttribute("data-no-swatch-selected");
      __privateMethod(this, _ProductCard_instances, updateOverflowList_fn).call(this);
    });
    /** @type {number | null} */
    __privateAdd(this, _previousSlideIndex, null);
    /**
     * Handles the slideshow select event.
     * @param {SlideshowSelectEvent} event - The slideshow select event.
     */
    __privateAdd(this, _handleSlideshowSelect, (event) => {
      if (event.detail.userInitiated) {
        __privateSet(this, _previousSlideIndex, event.detail.index);
      }
    });
    /**
     * Resets the image to the variant image.
     */
    __privateAdd(this, _resetVariant, () => {
      const { slideshow } = this.refs;
      if (!slideshow) return;
      if (this.variantPicker?.selectedOption) {
        const id = this.variantPicker.selectedOption.dataset.optionMediaId;
        if (id) {
          slideshow.select({ id }, void 0, { animate: false });
          return;
        }
      }
      const initialSlide = slideshow.initialSlide;
      const slideId = initialSlide?.getAttribute("slide-id");
      if (initialSlide && slideshow.slides?.includes(initialSlide) && slideId) {
        slideshow.select({ id: slideId }, void 0, { animate: false });
        return;
      }
      slideshow.previous(void 0, { animate: false });
    });
    /**
     * Intercepts the click event on the product card anchor, we want
     * to use this to add an intermediate state to the history.
     * This intermediate state captures the page we were on so that we
     * navigate back to the same page when the user navigates back.
     * In addition to that, it captures the product card anchor so that we
     * have the specific product card in view.
     *
     * A product card can have other interactive elements like variant picker,
     * so we do not navigate if the click was on one of those elements.
     *
     * @param {Event} event
     */
    __publicField(this, "navigateToProduct", (event) => {
      if (!(event.target instanceof Element)) return;
      if (this.hasAttribute("data-no-navigation")) return;
      const interactiveElement = event.target.closest('button, input, label, select, [tabindex="1"]');
      if (interactiveElement) {
        return;
      }
      const link = this.refs.productCardLink;
      if (!link.href) return;
      const linkURL = new URL(link.href);
      const productCardAnchor = link.getAttribute("id");
      if (!productCardAnchor) return;
      const infiniteResultsList = this.closest('results-list[infinite-scroll="true"]');
      if (!window.Shopify.designMode && infiniteResultsList) {
        const url = new URL(window.location.href);
        const parent = this.closest("li");
        url.hash = productCardAnchor;
        if (parent && parent.dataset.page) {
          url.searchParams.set("page", parent.dataset.page);
        }
        yieldToMainThread().then(() => {
          history.replaceState({}, "", url.toString());
        });
      }
      const targetLink = event.target.closest("a");
      if (!targetLink) {
        __privateGet(this, _navigateToURL).call(this, event, linkURL);
      }
    });
    /**
     * Resets the variant.
     */
    __publicField(this, "resetVariant", debounce(__privateGet(this, _resetVariant), 100));
  }
  get productPageUrl() {
    return this.refs.productCardLink.href;
  }
  /**
   * Gets the currently selected variant ID from the product card
   * @returns {string | null} The variant ID or null if none selected
   */
  getSelectedVariantId() {
    const checkedInput = (
      /** @type {HTMLInputElement | null} */
      this.querySelector('input[type="radio"]:checked[data-variant-id]')
    );
    return checkedInput?.dataset.variantId || null;
  }
  /**
   * Gets the product card link element
   * @returns {HTMLAnchorElement | null} The product card link or null
   */
  getProductCardLink() {
    return this.refs.productCardLink || null;
  }
  connectedCallback() {
    super.connectedCallback();
    const link = this.refs.productCardLink;
    if (!(link instanceof HTMLAnchorElement)) throw new Error("Product card link not found");
    __privateGet(this, _handleQuickAdd).call(this);
    this.addEventListener(ThemeEvents.variantUpdate, __privateGet(this, _handleVariantUpdate));
    this.addEventListener(ThemeEvents.variantSelected, __privateGet(this, _handleVariantSelected));
    this.addEventListener(SlideshowSelectEvent.eventName, __privateGet(this, _handleSlideshowSelect));
    mediaQueryLarge.addEventListener("change", __privateGet(this, _handleQuickAdd));
    this.addEventListener("click", this.navigateToProduct);
    setTimeout(() => {
      if (this.refs.slideshow?.isNested) {
        __privateMethod(this, _ProductCard_instances, preloadNextPreviewImage_fn).call(this);
      }
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", this.navigateToProduct);
  }
  /**
   * Updates the DOM with a new price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice(event) {
    const priceContainer = this.querySelectorAll(`product-price [ref='priceContainer']`)[1];
    const newPriceElement = event.detail.data.html.querySelector(`product-price [ref='priceContainer']`);
    if (newPriceElement && priceContainer) {
      morph(priceContainer, newPriceElement);
    }
  }
  /**
   * Gets all variant inputs.
   * @returns {NodeListOf<HTMLInputElement>} All variant input elements.
   */
  get allVariants() {
    return this.querySelectorAll("input[data-variant-id]");
  }
  /**
   * Gets the variant picker component.
   * @returns {VariantPicker | null} The variant picker component.
   */
  get variantPicker() {
    return this.querySelector("swatches-variant-picker-component");
  }
  /**
   * Previews a variant.
   * @param {string} id - The id of the variant to preview.
   */
  previewVariant(id) {
    const { slideshow } = this.refs;
    if (!slideshow) return;
    this.resetVariant.cancel();
    slideshow.select({ id }, void 0, { animate: false });
  }
  /**
   * Previews the next image.
   * @param {PointerEvent} event - The pointer event.
   */
  previewImage(event) {
    if (event.pointerType !== "mouse") return;
    const { slideshow } = this.refs;
    if (!slideshow) return;
    this.resetVariant.cancel();
    if (__privateGet(this, _previousSlideIndex) != null && __privateGet(this, _previousSlideIndex) > 0) {
      slideshow.select(__privateGet(this, _previousSlideIndex), void 0, { animate: false });
    } else {
      slideshow.next(void 0, { animate: false });
      setTimeout(() => __privateMethod(this, _ProductCard_instances, preloadNextPreviewImage_fn).call(this));
    }
  }
  /**
   * Resets the image to the variant image.
   * @param {PointerEvent} event - The pointer event.
   */
  resetImage(event) {
    if (event.pointerType !== "mouse") return;
    const { slideshow } = this.refs;
    if (!this.variantPicker) {
      if (!slideshow) return;
      slideshow.previous(void 0, { animate: false });
    } else {
      __privateGet(this, _resetVariant).call(this);
    }
  }
}
_fetchProductPageHandler = new WeakMap();
_navigateToURL = new WeakMap();
_ProductCard_instances = new WeakSet();
preloadNextPreviewImage_fn = function() {
  const currentSlide = this.refs.slideshow?.slides?.[this.refs.slideshow?.current];
  currentSlide?.nextElementSibling?.querySelector('img[loading="lazy"]')?.removeAttribute("loading");
};
_handleQuickAdd = new WeakMap();
_handleVariantSelected = new WeakMap();
_handleVariantUpdate = new WeakMap();
/**
 * Forces the overflow list to recalculate by dispatching a reflow event.
 * This ensures the overflow counter displays correctly after variant updates.
 */
updateOverflowList_fn = function() {
  const overflowList = this.querySelector("swatches-variant-picker-component overflow-list");
  const isActiveOverflowList = overflowList?.querySelector('[slot="overflow"]') ? true : false;
  if (!overflowList || !isActiveOverflowList) return;
  requestAnimationFrame(() => {
    overflowList.dispatchEvent(
      new CustomEvent("reflow", {
        bubbles: true,
        detail: {}
      })
    );
  });
};
/**
 * Updates the product URL based on the variant update event.
 * @param {VariantUpdateEvent} event - The variant update event.
 */
updateProductUrl_fn = function(event) {
  const responseProductCard = event.detail.data.html?.querySelector("product-card");
  const anchorElement = responseProductCard?.querySelector("a");
  const featuredMediaUrl = responseProductCard?.getAttribute("data-featured-media-url");
  if (featuredMediaUrl) {
    this.setAttribute("data-featured-media-url", featuredMediaUrl);
  }
  if (anchorElement instanceof HTMLAnchorElement) {
    if (anchorElement.getAttribute("href")?.trim() === "") return;
    const productUrl = anchorElement.href;
    const { productCardLink, productTitleLink, cardGalleryLink } = this.refs;
    productCardLink.href = productUrl;
    if (cardGalleryLink instanceof HTMLAnchorElement) {
      cardGalleryLink.href = productUrl;
    }
    if (productTitleLink instanceof HTMLAnchorElement) {
      productTitleLink.href = productUrl;
    }
  }
};
/**
 * Checks if an unavailable variant is selected.
 * @param {VariantUpdateEvent} event - The variant update event.
 */
isUnavailableVariantSelected_fn = function(event) {
  const allVariants = (
    /** @type {NodeListOf<HTMLInputElement>} */
    event.detail.data.html.querySelectorAll("input:checked")
  );
  for (const variant of allVariants) {
    __privateMethod(this, _ProductCard_instances, toggleAddToCartButton_fn).call(this, variant.dataset.optionAvailable === "true");
  }
};
/**
 * Toggles the add to cart button state.
 * @param {boolean} enable - Whether to enable or disable the button.
 */
toggleAddToCartButton_fn = function(enable) {
  const addToCartButton = this.querySelector(".add-to-cart__button button");
  if (addToCartButton instanceof HTMLButtonElement) {
    addToCartButton.disabled = !enable;
  }
};
/**
 * Hide the variant images that are not for the selected variant.
 */
updateVariantImages_fn = function() {
  const { slideshow } = this.refs;
  if (!this.variantPicker?.selectedOption) {
    return;
  }
  const selectedImageId = this.variantPicker?.selectedOption.dataset.optionMediaId;
  if (slideshow && selectedImageId) {
    const { slides = [] } = slideshow.refs;
    for (const slide of slides) {
      if (slide.getAttribute("variant-image") == null) continue;
      slide.hidden = slide.getAttribute("slide-id") !== selectedImageId;
    }
    slideshow.select({ id: selectedImageId }, void 0, { animate: false });
  }
};
_previousSlideIndex = new WeakMap();
_handleSlideshowSelect = new WeakMap();
_resetVariant = new WeakMap();
if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
class SwatchesVariantPickerComponent extends VariantPicker {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SwatchesVariantPickerComponent_instances);
  }
  connectedCallback() {
    super.connectedCallback();
    this.parentProductCard = this.closest("product-card");
    this.addEventListener(ThemeEvents.variantUpdate, __privateMethod(this, _SwatchesVariantPickerComponent_instances, handleCardVariantUrlUpdate_fn).bind(this));
  }
  /**
   * Override the variantChanged method to handle unavailable swatches with available alternatives.
   * @param {Event} event - The variant change event.
   */
  variantChanged(event) {
    if (!(event.target instanceof HTMLElement)) return;
    const isSwatchInput = event.target instanceof HTMLInputElement && event.target.name?.includes("-swatch");
    const clickedSwatch = event.target;
    const availableCount = parseInt(clickedSwatch.dataset.availableCount || "0");
    const firstAvailableVariantId = clickedSwatch.dataset.firstAvailableOrFirstVariantId;
    if (isSwatchInput && availableCount > 0 && firstAvailableVariantId) {
      event.stopPropagation();
      this.updateSelectedOption(clickedSwatch);
      const productUrl = this.dataset.productUrl?.split("?")[0];
      if (!productUrl) return;
      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set("variant", firstAvailableVariantId);
      url.searchParams.set("section_id", "section-rendering-product-card");
      const requestUrl = url.href;
      this.pendingVariantId = firstAvailableVariantId;
      this.fetchUpdatedSection(requestUrl);
      return;
    }
    super.variantChanged(event);
  }
  /**
   * Shows all swatches.
   * @param {Event} [event] - The event that triggered the show all swatches.
   */
  showAllSwatches(event) {
    event?.preventDefault();
    const { overflowList } = this.refs;
    if (overflowList instanceof OverflowList) {
      overflowList.showAll();
    }
  }
}
_SwatchesVariantPickerComponent_instances = new WeakSet();
/**
 * Updates the card URL when a variant is selected.
 */
handleCardVariantUrlUpdate_fn = function() {
  if (this.pendingVariantId && this.parentProductCard instanceof ProductCard) {
    const currentUrl = new URL(this.parentProductCard.refs.productCardLink.href);
    currentUrl.searchParams.set("variant", this.pendingVariantId);
    this.parentProductCard.refs.productCardLink.href = currentUrl.toString();
    this.pendingVariantId = null;
  }
};
if (!customElements.get("swatches-variant-picker-component")) {
  customElements.define("swatches-variant-picker-component", SwatchesVariantPickerComponent);
}
export {
  ProductCard,
  ProductCardLink
};
